import { GridFilterOperator } from '@mui/x-data-grid-pro'

import { Autocomplete } from '@collaborate-health/uikit'
import { GetQualificationResponse } from '@tabeeb/contracts/microservices/swagger-certificate-service'

import { useCertificateLocations } from '../../hooks'

const LocationGridFilterOperator: GridFilterOperator<GetQualificationResponse>['InputComponent'] = ({
  item,
  applyValue,
}) => {
  const { loading, locations } = useCertificateLocations()

  const filterValue: number[] = item?.value ?? []

  return (
    <Autocomplete
      size='small'
      disabled={loading}
      loading={loading}
      multiple
      fullWidth
      limitTags={5}
      value={locations.filter((l) => filterValue.includes(l.Id))}
      options={locations}
      getOptionKey={(option) => option.Id}
      getOptionLabel={(option) => option.Name}
      groupBy={(option) => option.CountryName}
      label='Locations'
      placeholder='Search locations...'
      isOptionEqualToValue={(option, value) => option.Id === value.Id}
      onChange={(event, newValues) => {
        applyValue({
          ...item,
          value: (newValues ?? []).map((location) => location.Id),
        })
      }}
      disableCloseOnSelect
    />
  )
}

export default LocationGridFilterOperator

